import { useState } from 'react';
import style from './FAQSection.module.css';

const faqData = [
	{
	  question: "What are Global Capability Centers?",
	  answer:
		'<a href="https://www.nytimes.com/2025/03/26/business/india-jobs-global-capability-center.html" target="_blank" rel="noopener noreferrer nofollow">Global Capability Centers (GCCs)</a>, also known as Captive Centers/Global-In-House centers are offshore /nearshore units, wholly owned and operated by the parent company to centralize functions such as Information technology, Finance, Human Resources etc.',
	},
	{
	  question: "What is a Mid-Market Global Capability Center (GCC)?",
	  answer:
		'A <a href="https://timesofindia.indiatimes.com/city/hyderabad/india-home-to-over-480-mid-market-gccs-employing-over-2-lakh-employees/articleshow/120528994.cms" target="_blank" rel="noopener noreferrer nofollow">Mid-Market GCC</a> is a global operations center that typically supports a company\'s strategic objectives and has revenue of USD 100 Million to 1 Billion. Unlike large-scale centers, these GCCs are agile, innovation-led hubs that often handle business-critical functions such as product engineering, AI/ML development, customer experience transformation, and digital innovation.',
	},
	{
	  question: "Why are Mid-Market GCCs important?",
	  answer:
		"Mid-Market GCCs are becoming crucial because they combine the advantages of agility, specialization, and strategic ownership. According to the Zinnov-nasscom Mid-Market Global Capability Centers (GCC) Report FY2025, these centers are no longer just operational extensions but are directly influencing business outcomes, accelerating innovation, and driving customer impact for global enterprises. ",
	},
	{
	  question: "How do Mid-Market GCCs differ from larger GCCs?",
	  answer:
		"Mid-Market GCCs operate with leaner structures, faster decision-making, and closer alignment with global leadership. Unlike larger GCCs, which are often process-heavy and scaled for operational efficiency, mid-sized centers emphasize entrepreneurship, niche expertise, and ownership of specific innovation mandates such as AI, cybersecurity, and cloud engineering.",
	},
	{
	  question: "Which industries are seeing the highest growth in Mid-Market GCCs?",
	  answer:
		"Industries like enterprise software, fintech, healthcare are leading the growth in Mid-Market GCCs. The demand in sectors such as HealthTech and FinTech is driving companies to establish specialized high-value centers focused on digital transformation and emerging technologies.",
	},
	{
	  question: "Where are Mid-Market GCCs being set up in India?",
	  answer:
		'While cities like <a href="https://analyticsindiamag.com/gcc/why-bengaluru-is-focusing-on-mid-market-gccs/" target="_blank" rel="noopener noreferrer">Bengaluru</a>, <a href="https://www.thehindu.com/news/cities/Hyderabad/hyderabad-a-talent-hotspot-for-mid-market-gccs/article69478951.ece" target="_blank" rel="noopener noreferrer nofollow">Hyderabad</a>, and Pune remain prominent... More than 20% of new mid-market expansions are happening in these <a href="https://zinnov.com/centers-of-excellence/how-tier-2-talent-is-powering-india-global-capability-centers-blog/" target="_blank" rel="noopener noreferrer">Tier-II and Tier-III cities</a> due to talent availability, cost advantages, and proactive government support.',
	},
	{
	  question: "What challenges do Mid-Market GCCs typically face?",
	  answer:
		"Scaling talent while maintaining culture, building strong brand recognition, and navigating complex compliance environments are common challenges. Mid-Market GCCs must also craft distinct value propositions to attract and retain digital and AI talent, as competition with startups and larger centers intensifies.",
	},
	{
	  question: "What capabilities do Mid-Market GCCs focus on?",
	  answer:
		'Mid-Market GCCs are increasingly <a href="https://zinnov.com/centers-of-excellence/what-is-center-of-excellence-coe-and-why-should-organizations-set-it-up-blog/" target="_blank" rel="noopener noreferrer">setting up Centers of Excellence (CoEs)</a> across AI/ML, cybersecurity, product development, customer experience, and cloud modernization. They are becoming mini-innovation hubs with ownership over digital transformation programs, engineering initiatives, and customer-impact mandates.',
	},
	{
	  question: "Are Mid-Market GCCs still considered cost-saving units?",
	  answer:
		"No. The perception of Mid-Market GCCs as cost centers has evolved significantly. More and more of these centers now own P&L responsibilities, product roadmaps, or digital innovation charters. They are positioned as value creation hubs, contributing directly to growth, resilience, and customer-centric outcomes for their parent organizations.",
	},
	{
	  question: "How do Mid-Market GCCs attract and retain top talent?",
	  answer:
		"Mid-Market GCCs attract talent by offering meaningful, high-ownership roles, faster career growth, and opportunities to work on global innovation programs. Many invest heavily in upskilling, mentoring, and partnerships with universities, while promoting purpose-driven careers that allow employees to see tangible business impact. ",
	},
	{
	  question: "What is the future outlook for Mid-Market GCCs?",
	  answer:
		"Mid-Market GCCs are poised for rapid expansion and transformation. According to the report, the next wave of growth will be defined by \"AI-native\" operations, deeper integration with global business strategy, and a stronger shift toward innovation leadership. These centers will be central to global enterprises' resilience, customer growth, and competitive advantage in the coming years ",
	},
  ];
  
  

const FAQSection = () => {
	const [activeIndex, setActiveIndex] = useState(null);
  
	const toggleAccordion = (index) => {
	  setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
	};
  
	return (
	  <section id={style.faqSection} className={style.sectionPadding}>
		<div className={style.container}>
		  <div className={style.row}>
			<div className={style.sectionHeading}>
			  <h4 className={`${style.sectionTitle} Heading Title ${style.textWhite}`}>FAQs</h4>
			</div>
			<div id="accordion" className={`${style.myaccordion} ${style.faqAccordion}`}>
			  {faqData.map((faq, index) => (
				<div className={style.card} key={index}>
				  <div className={style.cardHeader}>
					<button
					  className={`${style.btn} ${activeIndex === index ? style.active : ""}`}
					  onClick={() => toggleAccordion(index)}
					  aria-expanded={activeIndex === index}
					  aria-controls={`collapse_${index}`}
					>
					  <span className={style.icon}>
						{activeIndex === index ? "-" : "+"}
					  </span>
					  <p>{faq.question}</p>
					</button>
				  </div>
				  <div
					id={`collapse_${index}`}
					className={`${style.collapse} ${activeIndex === index ? style.show : ""}`}
					aria-labelledby={`heading${index}`}
					>
					<div className={style.cardBody} dangerouslySetInnerHTML={{ __html: faq.answer }} />
					</div>
				</div>
			  ))}
			</div>
		  </div>
		</div>
	  </section>
	);
  };
  
  export default FAQSection;